import _asyncToGenerator from "/home/circleci/project/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/circleci/project/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/circleci/project/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/circleci/project/frontend/node_modules/@babel/runtime/regenerator/index.js";
import { logger, uuid4, normalize, GLOBAL_OBJ } from '@sentry/utils';
import localForage from 'localforage';
var WINDOW = GLOBAL_OBJ;

/**
 * cache offline errors and send when connected
 * @deprecated The offline integration has been deprecated in favor of the offline transport wrapper.
 *
 * http://docs.sentry.io/platforms/javascript/configuration/transports/#offline-caching
 */
var Offline = /*#__PURE__*/function () {
  /**
   * the current hub instance
   */

  /**
   * maximum number of events to store while offline
   */

  /**
   * event cache
   */

  /**
   * @inheritDoc
   */
  function Offline() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Offline);
    Offline.prototype.__init.call(this);
    this.maxStoredEvents = options.maxStoredEvents || 30; // set a reasonable default
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.offlineEventStore = localForage.createInstance({
      name: 'sentry/offlineEventStore'
    });
  }

  /**
   * @inheritDoc
   */
  _createClass(Offline, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = Offline.id;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce(addGlobalEventProcessor, getCurrentHub) {
      var _this = this;
      this.hub = getCurrentHub();
      if ('addEventListener' in WINDOW) {
        WINDOW.addEventListener('online', function () {
          void _this._sendEvents().catch(function () {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('could not send cached events');
          });
        });
      }
      var eventProcessor = function eventProcessor(event) {
        if (_this.hub && _this.hub.getIntegration(Offline)) {
          // cache if we are positively offline
          if ('navigator' in WINDOW && 'onLine' in WINDOW.navigator && !WINDOW.navigator.onLine) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('Event dropped due to being a offline - caching instead');
            void _this._cacheEvent(event).then(function (_event) {
              return _this._enforceMaxEvents();
            }).catch(function (_error) {
              (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('could not cache event while offline');
            });

            // return null on success or failure, because being offline will still result in an error
            return null;
          }
        }
        return event;
      };
      eventProcessor.id = this.name;
      addGlobalEventProcessor(eventProcessor);

      // if online now, send any events stored in a previous offline session
      if ('navigator' in WINDOW && 'onLine' in WINDOW.navigator && WINDOW.navigator.onLine) {
        void this._sendEvents().catch(function () {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('could not send cached events');
        });
      }
    }

    /**
     * cache an event to send later
     * @param event an event
     */
  }, {
    key: "_cacheEvent",
    value: function () {
      var _cacheEvent2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.offlineEventStore.setItem(uuid4(), normalize(event)));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _cacheEvent(_x) {
        return _cacheEvent2.apply(this, arguments);
      }
      return _cacheEvent;
    }()
    /**
     * purge excess events if necessary
     */
  }, {
    key: "_enforceMaxEvents",
    value: function () {
      var _enforceMaxEvents2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        var events;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              events = [];
              return _context2.abrupt("return", this.offlineEventStore.iterate(function (event, cacheKey, _index) {
                // aggregate events
                events.push({
                  cacheKey: cacheKey,
                  event: event
                });
              }).then(function () {
                return (
                  // this promise resolves when the iteration is finished
                  _this2._purgeEvents(
                  // purge all events past maxStoredEvents in reverse chronological order
                  events.sort(function (a, b) {
                    return (b.event.timestamp || 0) - (a.event.timestamp || 0);
                  }).slice(_this2.maxStoredEvents < events.length ? _this2.maxStoredEvents : events.length).map(function (event) {
                    return event.cacheKey;
                  }))
                );
              }).catch(function (_error) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('could not enforce max events');
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _enforceMaxEvents() {
        return _enforceMaxEvents2.apply(this, arguments);
      }
      return _enforceMaxEvents;
    }()
    /**
     * purge event from cache
     */
  }, {
    key: "_purgeEvent",
    value: function () {
      var _purgeEvent2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cacheKey) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.offlineEventStore.removeItem(cacheKey));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _purgeEvent(_x2) {
        return _purgeEvent2.apply(this, arguments);
      }
      return _purgeEvent;
    }()
    /**
     * purge events from cache
     */
  }, {
    key: "_purgeEvents",
    value: function () {
      var _purgeEvents2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cacheKeys) {
        var _this3 = this;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", Promise.all(cacheKeys.map(function (cacheKey) {
                return _this3._purgeEvent(cacheKey);
              })).then());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function _purgeEvents(_x3) {
        return _purgeEvents2.apply(this, arguments);
      }
      return _purgeEvents;
    }()
    /**
     * send all events
     */
  }, {
    key: "_sendEvents",
    value: function () {
      var _sendEvents2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this4 = this;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.offlineEventStore.iterate(function (event, cacheKey, _index) {
                if (_this4.hub) {
                  _this4.hub.captureEvent(event);
                  void _this4._purgeEvent(cacheKey).catch(function (_error) {
                    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('could not purge event from cache');
                  });
                } else {
                  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('no hub found - could not send cached event');
                }
              }));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function _sendEvents() {
        return _sendEvents2.apply(this, arguments);
      }
      return _sendEvents;
    }()
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'Offline';
    }
  }]);
  return Offline;
}();
Offline.__initStatic();
export { Offline };